import { Component, EventEmitter, Input, OnInit, Output, signal } from '@angular/core';
import { UniSearchResponse } from 'src/app/interfaces/api';
import { UniService } from 'src/app/services/uni.service';
import { NgIf, NgFor } from '@angular/common';
import { University } from '../../models/university.model';

@Component({
    selector: 'app-uni-list',
    templateUrl: './uni-list.component.html',
    styleUrls: ['./uni-list.component.scss'],
    imports: [NgIf, NgFor],
})
export class UniListComponent implements OnInit {
  @Input() public noUnisFoundForLetterMessage: string | null = '';

  @Output() private readonly showChange = new EventEmitter<boolean>();

  @Output() private readonly alternativeUni = new EventEmitter<void>();

  @Output() private readonly uniSelected = new EventEmitter<University>();

  @Output() private readonly addUni = new EventEmitter<string>();

  public readonly letterGroups = [
    'A - C',
    'D - F',
    'G - I',
    'J - L',
    'M - O',
    'P - R',
    'S - U',
    'V - Z',
  ];

  public readonly universities = signal<University[]>([]);

  public readonly currentList = signal<University[] | null>(null);

  public readonly currentGroup = signal('A - C');

  public readonly unisLoaded = signal(false);

  constructor(private readonly uniService: UniService) {}

  ngOnInit(): void {
    this.uniService.getUniversitiesGroupedByLetter('A', 'Z').subscribe({
      next: (res) => {
        const results = <UniSearchResponse>res;
        this.universities.set(results.data.data);
      },
      error: () => {},
      complete: () => {
        this.unisLoaded.set(true);
        this.selectList(this.currentGroup());
      },
    });
  }

  public selectUni(uni: University): void {
    this.uniSelected.emit(uni);
  }

  public doAddUni(): void {
    this.addUni.emit('');
  }

  public notAtUni(): void {
    this.alternativeUni.emit();
  }

  public isSelectable(group: string): boolean {
    return this.getList(group).length > 0;
  }

  private getList(group: string): University[] {
    const [start, end] = group.split(' - ');
    return this.universities()
      .filter((uni) => {
        const a = uni.name.toUpperCase().charAt(0);
        return a >= start && a <= end && uni.isSearchable;
      })
      .sort((a, b) => {
        if (a.name.toUpperCase() > b.name.toUpperCase()) return 1;
        if (a.name.toUpperCase() < b.name.toUpperCase()) return -1;
        return 0;
      });
  }

  public selectList(group: string): void {
    this.currentList.set(this.getList(group));
    this.currentGroup.set(group);
  }

  public isSelected(g: string): boolean {
    return g === this.currentGroup();
  }
}
